import React, { useEffect, useState } from "react";
import {
  Modal,
  Select,
  Input,
  Button,
  DatePicker,
  Upload,
  message,
} from "antd";
import {
  InboxOutlined,
  EyeOutlined,
  DeleteOutlined,
  EyeTwoTone,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store/store";
import {
  fetchProceduresForEnhancement,
  fetchSpecialitiesForEnhancement,
  UploadDocument,
} from "../../../models/EnhancementSlice";
import FilePreviewModal from "../PreAuth-query/FilePreviewModal";
import { IUploadReferral } from "../../../interfaces/IReferral";
import {
  fetchEnhancements,
  submitCaseEnhancement,
} from "../../../models/EnhancementSliceForCghs";
import {
  CaseEnhancementPayload,
  CaseEnhancementProcedure,
} from "../../../interfaces/IEnhancementForCghs";
import moment, { Moment } from "moment";
import "./NewEnhancementModal.css";
import { getDocuments } from "../../../apis/schemeService";
import "./NewEnhancementModal.css";
import { Form } from "antd";

const { Option } = Select;

interface EnhancementModalForCghsProps {
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  portalMetaDataId: number;
  onfetchStepper: () => void;
  claimId: string;
}

interface Document {
  id: number;
  type?: string;
  file?: any;
  documentId?: any;
}

interface ProcedureRow {
  id: number;
  procedure: string;
  amount: string;
}

const EnhancementModal: React.FC<EnhancementModalForCghsProps> = ({
  isModalOpen,
  setIsModalOpen,
  portalMetaDataId,
  onfetchStepper,
  claimId,
}) => {
  const [form] = Form.useForm();
  const { preAuth } = useSelector((state: RootState) => state);
  const [isProcedureEnabled, setIsProcedureEnabled] = useState<boolean>(false);
  const [procedureRows, setProcedureRows] = useState<ProcedureRow[]>([
    { id: 1, procedure: "", amount: "" },
  ]);
  const [isShiftEnabled, setIsShiftEnabled] = useState<boolean>(false);
  const [isDaysEnabled, setIsDaysEnabled] = useState<boolean>(false);
  const [requestedAmount, setRequestedAmount] = useState<string>("");
  const [selectedShift, setSelectedShift] = useState<string>("");
  const [shiftAmount, setShiftAmount] = useState<string>("");
  const [numberOfDays, setNumberOfDays] = useState<string>("");
  const [initiatedDate, setinitiatedDate] = useState<string>("");
  const [daysAmount, setDaysAmount] = useState<string>("");
  const [totalEnhancementAmount, setTotalEnhancementAmount] =
    useState<string>("");
  const [documents, setDocuments] = useState<Document[]>([
    { id: 1, type: undefined, file: undefined },
  ]);
  const [uploadFileModal, setUploadFileModal] = useState<boolean>(false);
  const [documentsForDrawer, setDocumentsForDrawer] = useState<Document[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [previewFile, setPreviewFile] = useState({
    url: "",
    name: "",
    showUpload: false,
    // documentType: "",
  });
  const [selectedFile, setSelectedFile] = useState<IUploadReferral>({
    file: {},
    documentType: "",
  });
  const { patients, auth, hospital, enhancementCghs } = useSelector(
    (state: RootState) => state
  );
  const dispatch = useDispatch<AppDispatch>();
  const procedures = enhancementCghs?.procedures;

  const [documentUrls, setDocumentUrls] = useState<
    {
      documentType: string;
      documentName: string;
      documentUrl: string;
      id: number;
      referenceType: string | null;
      documentLabelType: string | null;
      deficiencyCheckStatus: string | null;
      remarks: string | null;
    }[]
  >([]);

  const [procedureNames, setProcedureNames] = useState(
    procedures?.map((item: any) => item.procedureName)
  );

  const handleCancel = (): void => {
    setIsModalOpen(false);
  };

  const handleAddRow = (): void => {
    setDocuments((prev) => [
      ...prev,
      { id: prev.length + 1, type: undefined, file: undefined },
    ]);
  };

  const schemeMetaDataId =
    patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId;

  useEffect(() => {
    if (portalMetaDataId && schemeMetaDataId) {
      const fetchDocuments = async () => {
        setLoading(true);
        try {
          const data = await getDocuments(portalMetaDataId, schemeMetaDataId);
          const uniqueDocuments = Object.values(data)
            .flat()
            ?.filter(
              (doc: any, index: number, self: any[]) =>
                index === self.findIndex((t: any) => t.label === doc.label)
            )
            ?.map((doc: any) => ({ id: doc.value, value: doc.label }));

          setDocumentsForDrawer(uniqueDocuments);
        } catch (err) {
          message.error("Failed to fetch documents.");
        } finally {
          setLoading(false);
        }
      };

      fetchDocuments();
    }
  }, [portalMetaDataId, schemeMetaDataId]);

  const handleAddProcedureRow = () => {
    setProcedureRows((prev) => [
      ...prev,
      {
        id: prev.length + 1,
        procedure: "",
        amount: "",
      },
    ]);
  };
  const updateProcedureRow = (
    id: number,
    field: keyof ProcedureRow,
    value: string
  ) => {
    if (field === "amount") {
      if (!validateNumericInput(value)) return;
    }
    setProcedureRows((prev) =>
      prev?.map((row) => (row.id === id ? { ...row, [field]: value } : row))
    );
  };

  useEffect(() => {
    const procedureTotal = procedureRows.reduce(
      (sum, row) => sum + (parseFloat(row.amount) || 0),
      0
    );
    const shiftTotal = isShiftEnabled ? parseFloat(shiftAmount) || 0 : 0;
    const daysTotal = isDaysEnabled ? parseFloat(daysAmount) || 0 : 0;

    const total = procedureTotal + shiftTotal + daysTotal;
    setTotalEnhancementAmount(total.toString());
  }, [procedureRows, isShiftEnabled, isDaysEnabled, shiftAmount, daysAmount]);

  const handleFileChange = (file: File, index: number): void => {
    const updatedDocs = [...documents];
    updatedDocs[index].file = file;

    setSelectedFile({
      file: file,
      documentType: updatedDocs[index]?.type || "OTHERS", // Use selected type or default to "OTHERS"
    });

    setPreviewFile({
      url: URL.createObjectURL(file),
      name: file.name,
      showUpload: true,
    });

    setDocuments(updatedDocs);
    setUploadFileModal(true);
  };

  const validateNumericInput = (value: string): boolean => {
    const numericRegex = /^\d*\.?\d*$/;
    return numericRegex.test(value);
  };

  const handleAmountChange = (
    value: string,
    setter: (value: string) => void
  ) => {
    if (value === "" || validateNumericInput(value)) {
      setter(value);
    }
  };

  const validateForm = (): boolean => {
    if (!initiatedDate) {
      message.error("Please select an initiated date");
      return false;
    }

    if (!isProcedureEnabled && !isShiftEnabled && !isDaysEnabled) {
      message.error("Please select at least one enhancement type");
      return false;
    }

    if (isProcedureEnabled) {
      const invalidProcedures = procedureRows.some(
        (row) => !row.procedure || !row.amount
      );
      if (invalidProcedures) {
        message.error("Please fill all procedure details");
        return false;
      }
    }

    if (isShiftEnabled) {
      if (!selectedShift || !shiftAmount) {
        message.error("Please fill all shift details");
        return false;
      }
    }

    if (isDaysEnabled) {
      if (!numberOfDays || !daysAmount) {
        message.error("Please fill all days details");
        return false;
      }
    }

    return true;
  };

  const handleTypeChange = (
    value: string,
    index: number,
    documentId?: any
  ): void => {
    const updatedDocs = [...documents];
    updatedDocs[index] = {
      ...updatedDocs[index],
      type: value,
      documentId: documentId, // Store the document ID
    };
    setDocuments(updatedDocs);
  };

  const handleUpload = async () => {
    const CollectPostData = new FormData();

    if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
      CollectPostData.append(
        "hospitalId",
        patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString()
      );
    }
    if (patients?.fetchBasicDetails?.patientResponse?.id) {
      CollectPostData.append(
        "patientId",
        patients?.fetchBasicDetails?.patientResponse?.id?.toString()
      );
    }
    if (patients?.fetchBasicDetails?.casesResponse?.id) {
      CollectPostData.append(
        "caseId",
        patients?.fetchBasicDetails?.casesResponse?.id.toString()
      );
    }
    if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
      CollectPostData.append(
        "visitId",
        patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString()
      );
    }
    const currentDocument = documents.find(
      (doc) => doc.file === selectedFile.file
    );

    // Ensure the selected document type (ID) is passed
    CollectPostData.append(
      "documentType",
      currentDocument?.documentId || "OTHERS"
    );

    if (selectedFile?.file) {
      CollectPostData.append("file", selectedFile?.file);
    }

    try {
      const resp = await dispatch(
        UploadDocument({
          formData: CollectPostData,
          accessToken: auth.accessToken || "",
        })
      ).unwrap();

      if (resp?.documentUrl) {
        message.success(`${resp?.documentLabelType} uploaded successfully`);
        setDocumentUrls((prev) => [
          ...prev,
          {
            documentType: resp.documentType || "Others",
            //
            documentName: resp.documentName || "Others",
            documentUrl: resp.documentUrl,
            id: resp.id,
            referenceType: resp.referenceType || null,
            documentLabelType: resp.documentLabelType || null,
            deficiencyCheckStatus: resp.deficiencyCheckStatus || null,
            remarks: resp.remarks || null,
          },
        ]);
      } else {
        message.error("Please Upload Again");
      }
      setUploadFileModal(false);
    } catch (error) {
      console.error("Failed to upload document:", error);
      message.error("Failed to upload document. Please try again.");
    }
  };

  const handleDeleteRow = (index: number): void => {
    const docId = documentUrls[index]?.id;

    // Remove from documentUrls
    const updatedDocumentUrls = documentUrls?.filter((_, idx) => idx !== index);
    setDocumentUrls(updatedDocumentUrls);

    // Reset the specific document's file and uploaded status
    const updatedDocuments = documents?.map((doc, idx) =>
      idx === index ? { ...doc, file: undefined, uploaded: false } : doc
    );
    setDocuments(updatedDocuments);

    // Optionally, make an API call to delete the document on the server
    // dispatch(deleteDocument(docId)); // Implement this action if required
  };

  const handleInitiateEnhancement = () => {
    // Validate inputs
    // if (!dateOfAdmission || !dateOfDischarge) {
    //   message.error("Please select admission and discharge dates");
    //   return;
    // }

    if (!validateForm()) {
      return;
    }

    const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
    const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;
    // const portalMetaDataId = patients?.fe
    if (caseId && visitId) {
      // Prepare procedures list
      const enhancementProceduresRequestList: CaseEnhancementProcedure[] =
        isProcedureEnabled
          ? procedureRows?.map((row) => ({
              procedure: row.procedure,
              amount: row.amount,
              id: row.id,
            }))
          : [];

      // Prepare payload
      const payload: CaseEnhancementPayload = {
        dateOfAdmission:
          patients?.fetchBasicDetails?.visitInfoResponse?.doa || "",
        dateOfDischarge:
          patients?.fetchBasicDetails?.visitInfoResponse?.dod || "",
        documentUrls: documentUrls,
        status: true,
        requestedAmount: totalEnhancementAmount,
        multipleCaseEnhancementRequest: {
          shiftAmount: isShiftEnabled ? shiftAmount : "0",
          noOfDays: isDaysEnabled ? numberOfDays : "0",
          noOfDaysAmount: isDaysEnabled ? daysAmount : "0",
          treatingDoctor:
            patients?.fetchBasicDetails?.visitInfoResponse?.doctorName || "",
          shift: isShiftEnabled ? selectedShift : "",
          totalEnhancementAmount: totalEnhancementAmount,
          initiatedDate: initiatedDate ? initiatedDate : "",
          enhancementProceduresRequestList: enhancementProceduresRequestList,
        },
      };

      // Dispatch enhancement submission
      dispatch(
        submitCaseEnhancement({ caseId, visitId, portalMetaDataId, payload })
      )
        .unwrap()
        .then(() => {
          onfetchStepper();
          dispatch(fetchEnhancements({ caseId, visitId }));
          message.success("Enhancement initiated successfully");
          setIsModalOpen(false);
        })
        .catch((error) => {
          message.error("Failed to initiate enhancement");
          console.error(error);
        });
    }
  };

  const handleSearch = (value: string) => {
    const filtered = procedureNames?.filter(
      (option: any) =>
        option.toLowerCase().includes(value.toLowerCase()) ||
        value.trim() === ""
    );
    setProcedureNames(filtered);
  };

  const handleDateChange = (date: Moment | null) => {
    if (date) {
      setinitiatedDate(date.format("DD-MM-YYYY")); // Format the date to DD-MM-YYYY
    } else {
      setinitiatedDate(""); // Handle null or cleared value
    }
  };
  return (
    <Modal
      title={null}
      open={isModalOpen}
      centered
      footer={null}
      onCancel={handleCancel}
      width={1100}
      style={{ padding: "4px" }}
    >
      <Form form={form} layout="vertical">
        <div
          style={{
            borderRadius: "8px",
            padding: "14px",
          }}
        >
          {/* Header */}
          <div
            style={{
              display: "flex",
              gap: "3%",
              alignItems: "center",
              marginBottom: "16px",
            }}
          >
            <div>
              <span style={{ fontWeight: "600" }}>Claim Id :</span>
              <span
                style={{
                  marginLeft: "8px",
                  backgroundColor: "rgba(0, 0, 0, 0.04)",
                  padding: "8px",
                  borderRadius: "10px",
                  border: "1px solid #d9d9d9",
                }}
              >
                {claimId}
              </span>
            </div>

            <div style={{ display: "flex", alignItems: "center" }}>
              <span style={{ fontWeight: "600", marginRight: "8px" }}>
                Treating Doctor:
              </span>
              <Input
                defaultValue={
                  patients?.fetchBasicDetails?.visitInfoResponse?.doctorName
                }
                style={{ width: "200px" }} // Adjust width as needed
                placeholder="Enter doctor name"
              />
            </div>
            <div>
              <span style={{ color: "#ff4d4f" }}>*</span>
              <span style={{ fontWeight: "600" }}> Initiated Date :</span>
              <DatePicker
                style={{ marginLeft: "8px" }}
                value={
                  initiatedDate ? moment(initiatedDate, "DD-MM-YYYY") : null
                } // Parse the string back to Moment
                onChange={handleDateChange}
                format="DD-MM-YYYY" // Ensure the date picker uses this format
              />
            </div>
          </div>

          <div
            style={{
              borderRadius: "8px",
              border: "1px solid #D9D9D9",
              padding: "20px",
            }}
          >
            {/* Checkboxes Row */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                marginBottom: "16px",
              }}
            >
              <div>
                <input
                  type="checkbox"
                  id="procedure"
                  checked={isProcedureEnabled}
                  onChange={(e) => setIsProcedureEnabled(e.target.checked)}
                  className="custom-checkbox"
                />
                <label htmlFor="procedure" className="custom-label">
                  Procedure
                </label>
              </div>
              <div>
                <input
                  type="checkbox"
                  id="shift"
                  checked={isShiftEnabled}
                  onChange={(e) => setIsShiftEnabled(e.target.checked)}
                  className="custom-checkbox"
                />
                <label htmlFor="shift" className="custom-label">
                  Shift
                </label>
              </div>
              <div>
                <input
                  type="checkbox"
                  id="days"
                  checked={isDaysEnabled}
                  onChange={(e) => setIsDaysEnabled(e.target.checked)}
                  className="custom-checkbox"
                />
                <label htmlFor="days" className="custom-label">
                  Days
                </label>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "16px", // Spacing between the two main sections
                marginBottom: "16px",
              }}
            >
              {/* Procedure Section */}
              <div
                style={{
                  flex: "1 1 48%", // Takes up approximately half of the container
                  border: "1px solid #D1D5DB",
                  borderRadius: "8px",
                  padding: "16px",
                  minWidth: "300px", // Minimum width for responsiveness
                }}
              >
                {/* Header Row */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "8px",
                  }}
                >
                  <span style={{ fontWeight: "600", width: "53%" }}>
                    Procedure Type{" "}
                    {isProcedureEnabled && (
                      <span style={{ color: "#ff4d4f" }}>*</span>
                    )}
                  </span>
                  <span
                    style={{
                      fontWeight: "600",
                      width: "43%",
                      textAlign: "left",
                    }}
                  >
                    Amount{" "}
                    {isProcedureEnabled && (
                      <span style={{ color: "#ff4d4f" }}>*</span>
                    )}
                  </span>
                </div>

                {/* Render Procedure Rows */}
                {procedureRows?.map((row, index) => (
                  <div
                    key={row.id}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "8px",
                    }}
                  >
                    {/* Procedure Dropdown */}
                    <Select
                      showSearch
                      style={{ width: "53%" }}
                      disabled={!isProcedureEnabled}
                      dropdownMatchSelectWidth={true}
                      getPopupContainer={(triggerNode) =>
                        triggerNode.parentElement
                      }
                      placeholder={`Procedure ${index + 1}${
                        isProcedureEnabled ? " *" : ""
                      }`}
                      defaultActiveFirstOption={true}
                      showArrow={true}
                      filterOption={false}
                      onSearch={handleSearch}
                      notFoundContent={null}
                      allowClear
                      defaultOpen={false}
                      value={row.procedure}
                      onChange={(value) =>
                        updateProcedureRow(row.id, "procedure", value)
                      }
                    >
                      {procedureNames?.map((procedure: any) => (
                        <Select.Option
                          key={procedure.id}
                          value={procedure}
                          style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {procedure}
                        </Select.Option>
                      ))}
                    </Select>

                    {/* Amount Input */}
                    <Input
                      prefix="₹"
                      placeholder="Amount"
                      style={{ width: "43%" }}
                      disabled={!isProcedureEnabled}
                      value={row.amount}
                      onChange={(e) =>
                        handleAmountChange(e.target.value, (value) =>
                          updateProcedureRow(row.id, "amount", value)
                        )
                      }
                      required={isProcedureEnabled}
                    />
                  </div>
                ))}

                {/* Add Row Button */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    marginTop: "16px",
                  }}
                >
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "#008B8B",
                      color: "white",
                      boxShadow: "0px 2px 8px 0px #00000040",
                    }}
                    disabled={!isProcedureEnabled}
                    onClick={handleAddProcedureRow}
                  >
                    ADD ROW
                  </Button>
                </div>
              </div>

              {/* Shift and Days Section */}
              <div
                style={{
                  flex: "1 1 48%", // Takes up approximately half of the container
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px", // Space between Shift and Days sections
                  minWidth: "300px", // Minimum width for responsiveness
                }}
              >
                {/* Shift Section */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    border: "1px solid #D1D5DB",
                    borderRadius: "8px",
                    padding: "16px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                    }}
                  >
                    {/* Shift Select Container */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "60%",
                      }}
                    >
                      <span style={{ marginBottom: "4px", fontWeight: "500" }}>
                        Shift{" "}
                        {isShiftEnabled && (
                          <span style={{ color: "#ff4d4f" }}>*</span>
                        )}
                      </span>
                      <Input
                        placeholder="Enter Shift"
                        disabled={!isShiftEnabled}
                        value={selectedShift}
                        onChange={(e) => setSelectedShift(e.target.value)}
                        style={{ width: "100%" }}
                      />
                    </div>

                    {/* Amount Input Container */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "35%",
                      }}
                    >
                      <span style={{ marginBottom: "4px", fontWeight: "500" }}>
                        Amount{" "}
                        {isShiftEnabled && (
                          <span style={{ color: "#ff4d4f" }}>*</span>
                        )}
                      </span>
                      <Input
                        prefix="₹"
                        placeholder="Shift Amount"
                        disabled={!isShiftEnabled}
                        value={shiftAmount}
                        onChange={(e) =>
                          handleAmountChange(e.target.value, setShiftAmount)
                        }
                        required={isShiftEnabled}
                      />
                    </div>
                  </div>
                </div>

                {/* Days Section */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    border: "1px solid #D1D5DB",
                    borderRadius: "8px",
                    padding: "16px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                    }}
                  >
                    {/* Days Select Container */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "60%",
                      }}
                    >
                      <span style={{ marginBottom: "4px", fontWeight: "500" }}>
                        Days{" "}
                        {isDaysEnabled && (
                          <span style={{ color: "#ff4d4f" }}>*</span>
                        )}
                      </span>
                      <Select
                        style={{ width: "100%" }}
                        placeholder="Select Days"
                        disabled={!isDaysEnabled}
                        value={numberOfDays}
                        onChange={setNumberOfDays}
                      >
                        {[...Array(30)]?.map((_, i) => (
                          <Select.Option key={i + 1} value={(i + 1).toString()}>
                            {i + 1}
                          </Select.Option>
                        ))}
                      </Select>
                    </div>

                    {/* Days Amount Input Container */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "35%",
                      }}
                    >
                      <span style={{ marginBottom: "4px", fontWeight: "500" }}>
                        Amount{" "}
                        {isDaysEnabled && (
                          <span style={{ color: "#ff4d4f" }}>*</span>
                        )}
                      </span>
                      <Input
                        prefix="₹"
                        placeholder="Days Amount"
                        disabled={!isDaysEnabled}
                        value={daysAmount}
                        onChange={(e) =>
                          handleAmountChange(e.target.value, setDaysAmount)
                        }
                        required={isDaysEnabled}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Total Enhancement Amount */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                // border: "1px solid #D1D5DB",
                // borderRadius: "8px",
                padding: "16px",
                marginBottom: "16px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  width: "30%",
                  paddingRight: "1rem",
                }}
              >
                <span style={{ fontWeight: "700" }}>
                  TOTAL ENHANCEMENT AMOUNT :
                </span>
              </div>
              <Input
                prefix="₹"
                placeholder="30,000"
                style={{ width: "70%" }}
                value={totalEnhancementAmount}
              />
            </div>

            {/* Documents Section */}
            <div
              style={{
                // borderRadius: "8px",
                display: "flex",

                // border: "1px solid #D9D9D9",
                padding: "8px 16px",
                // marginBottom: "16px",
              }}
            >
              <span
                style={{
                  fontWeight: "700",
                  width: "30%",
                  display: "flex",
                  justifyContent: "end",
                  paddingRight: "1rem",
                }}
              >
                DOCUMENTS :
              </span>
              <div
                style={{
                  borderRadius: "8px",
                  border: "1px solid #D9D9D9",
                  width: "70%",
                  padding: "2%",
                }}
              >
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    tableLayout: "fixed", // Ensures consistent column widths
                  }}
                >
                  <thead>
                    <tr>
                      <th
                        style={{
                          textAlign: "left",
                          padding: "8px",
                          borderTop: "1px solid #D9D9D9",
                          borderBottom: "1px solid #D9D9D9",
                          borderLeft: "1px solid #D9D9D9",
                          width: "30%", // Fixed width for the first column
                        }}
                      >
                        Document Type
                      </th>
                      <th
                        style={{
                          textAlign: "left",
                          padding: "8px",
                          borderTop: "1px solid #D9D9D9",
                          borderBottom: "1px solid #D9D9D9",
                          width: "50%", // Fixed width for the second column
                        }}
                      >
                        Selected File
                      </th>
                      <th
                        style={{
                          textAlign: "center",
                          padding: "8px",
                          borderTop: "1px solid #D9D9D9",
                          borderBottom: "1px solid #D9D9D9",
                          borderRight: "1px solid #D9D9D9",
                          width: "20%", // Fixed width for the third column
                        }}
                      >
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {documents?.map((doc, index) => (
                      <tr key={doc.id}>
                        <td
                          style={{
                            padding: "8px",
                            borderTop: "1px solid #D9D9D9",
                            borderBottom: "1px solid #D9D9D9",
                            borderLeft: "1px solid #D9D9D9",
                            overflow: "hidden", // Ensure no overflow
                            textOverflow: "ellipsis", // Ellipsis for overflow
                            whiteSpace: "nowrap", // Prevent wrapping
                          }}
                        >
                          <Select
                            style={{ width: "100%" }} // Fixed dropdown width
                            className="custom-dropdown"
                            placeholder="Document Type"
                            onChange={(value, option) => {
                              const selectedOption = Array.isArray(option)
                                ? option[0]
                                : option;
                              handleTypeChange(
                                value as string,
                                index,
                                selectedOption?.key as string
                              );
                            }}
                            value={doc.type}
                          >
                            {documentsForDrawer?.map((document: any) => (
                              <Option key={document.id} value={document.value}>
                                {document.value}
                              </Option>
                            ))}
                          </Select>
                        </td>
                        <td
                          style={{
                            padding: "15px",
                            // borderTop: "1px solid #D9D9D9",
                            borderBottom: "1px solid #D9D9D9",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap", // Prevent text wrapping
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <span
                            style={{
                              textDecoration: "underline",
                              cursor: "pointer",
                              color: "#1677FF",
                              fontWeight: "600",
                              display: "inline-block",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              maxWidth: "100%", // Ensure it respects column width
                            }}
                            title={doc.file ? doc.file.name : "Browse File"} // Show full filename on hover
                            onClick={() => {
                              const input = document.createElement("input");
                              input.type = "file";
                              input.onchange = (e: any) =>
                                handleFileChange(e.target.files[0], index);
                              input.click();
                            }}
                          >
                            {doc.file ? doc.file.name : "Browse File"}
                          </span>
                        </td>
                        <td
                          style={{
                            padding: "8px",
                            borderTop: "1px solid #D9D9D9",
                            borderBottom: "1px solid #D9D9D9",
                            borderRight: "1px solid #D9D9D9",
                            textAlign: "center",
                            overflow: "hidden",
                          }}
                        >
                          <Button
                            icon={<EyeOutlined />}
                            style={{
                              border: "none",
                              background: "none",
                              boxShadow: "none",
                            }}
                            disabled={!doc.file}
                            onClick={() =>
                              window.open(URL.createObjectURL(doc.file))
                            }
                          />
                          <Button
                            icon={<DeleteOutlined />}
                            style={{
                              border: "none",
                              background: "none",
                              boxShadow: "none",
                            }}
                            danger
                            disabled={!doc.file}
                            onClick={() => handleDeleteRow(index)}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    marginTop: "16px",
                  }}
                >
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "#008B8B",
                      color: "#fff",
                      boxShadow: "0px 2px 8px 0px #00000040",
                    }}
                    onClick={handleAddRow}
                  >
                    ADD ROW
                  </Button>
                </div>
              </div>
              {/* Add Row Button */}
            </div>
          </div>

          {/* Action Buttons */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "2%",
              gap: "5%",
            }}
          >
            <Button
              onClick={() => setIsModalOpen(false)}
              style={{
                borderColor: "#D2691E",
                color: "#D2691E",
                boxShadow: "0px 2px 8px 0px #00000040",
                width: "20%",
              }}
            >
              CANCEL
            </Button>
            <Button
              type="primary"
              style={{
                backgroundColor: "#D2691E",
                color: "#fff",
                boxShadow: "0px 2px 8px 0px #00000040",
                width: "20%",
              }}
              onClick={handleInitiateEnhancement}
            >
              INITIATE ENHANCEMENT
            </Button>
          </div>
        </div>
        <FilePreviewModal
          isVisible={uploadFileModal}
          onClose={() => setUploadFileModal(false)}
          fileUrl={previewFile.url}
          fileName={previewFile.name}
          // documentType={previewFile.documentType}
          handleUpload={handleUpload}
          showUploadButton={previewFile.showUpload}
          key={selectedFile?.file?.uid || "no-file"}
          //  isLoading={preAuthClaim?.isLoading}
        />
      </Form>
    </Modal>
  );
};

export default EnhancementModal;
